import type { ApiLanguage } from '../../api/types';
import type {
  AnimationLevel, FoldersPosition, PerformanceType, Point, Size, ThemeKey, TimeFormat,
} from '../../types';
import type { RasiTechModulesSettings } from './rasiTechModules';
import { DEFAULT_RASITECH_MODULES } from './rasiTechModules';

export type { RasiTechModulesSettings } from './rasiTechModules';
export {
  DEFAULT_PRIVATE_MODE,
  DEFAULT_CUSTOMIZATIONS,
  DEFAULT_EXTRA_BUTTONS,
  DEFAULT_WEBHOOK_SETTINGS,
  DEFAULT_SMART_REPLY_SETTINGS,
  DEFAULT_BROADCAST_SETTINGS,
  DEFAULT_RASITECH_MODULES,
} from './rasiTechModules';

export interface SharedState {
  settings: SharedSettings;
  isInitial?: true;
}

export interface RasiTechSettings {
  antiDelete: boolean;
  antiEditHistory: boolean;
  showPeerId: boolean;
  unrestrictMedia: boolean;
  androidMobileLayout: boolean;
  lightweight: boolean;
  fakeAdmin: boolean;
  fakePremium: boolean;
}

export const DEFAULT_RASITECH_SETTINGS: RasiTechSettings = {
  antiDelete: false,
  antiEditHistory: false,
  showPeerId: true,
  unrestrictMedia: true,
  androidMobileLayout: true,
  lightweight: true,
  fakeAdmin: false,
  fakePremium: false,
};

export interface ForensicSettings {
  autoIngest: boolean;
  serverUrl: string;
}

export const DEFAULT_FORENSIC_SETTINGS: ForensicSettings = {
  autoIngest: false,
  serverUrl: '',
};

export interface SharedSettings {
  rasiTech: RasiTechSettings;
  rasiTechModules: RasiTechModulesSettings;
  forensic: ForensicSettings;
  shouldUseSystemTheme: boolean;
  theme: ThemeKey;
  language: string;
  languages?: ApiLanguage[];
  performance: PerformanceType;
  messageTextSize: number;
  animationLevel: AnimationLevel;
  foldersPosition: FoldersPosition;
  // This can be deleted after September 2025, along with the corresponding migration
  wasAnimationLevelSetManually?: boolean;
  messageSendKeyCombo: 'enter' | 'ctrl-enter';
  miniAppsCachedPosition?: Point;
  miniAppsCachedSize?: Size;
  timeFormat: TimeFormat;
  wasTimeFormatSetManually: boolean;
  isConnectionStatusMinimized: boolean;
  canDisplayChatInTitle: boolean;
  shouldForceHttpTransport?: boolean;
  shouldAllowHttpTransport?: boolean;
  shouldCollectDebugLogs?: boolean;
  shouldDebugExportedSenders?: boolean;
  shouldWarnAboutFiles?: boolean;
  shouldSkipWebAppCloseConfirmation: boolean;
}
